import axios from 'axios'
import { apiUrl } from '../../apiUrl'

/* Cancel request */
const CancelTokenLoadNextRecordsQuery = axios.CancelToken
let cancelLoadNextRecordsQuery

const url = apiUrl()
const apiHeader = (token) => {
	return {
		Accept: 'application/json',
		Authorization: `Bearer ${token}`,
	}
}

export const mobileUnitsApi = {
	getViewData(token, cancelToken) {
		return axios.get(`${url}/devices/view`, {
			headers: apiHeader(token),
			cancelToken: cancelToken?.token,
		})
	},

	getColumns(token, cancelToken) {
		return axios.get(`${url}/devices/view/columns`, {
			headers: apiHeader(token),
			cancelToken: cancelToken?.token,
		})
	},

	getRecords(viewKey, viewSession, filter, token) {
		const config = {
			headers: apiHeader(token),
			cancelToken: new CancelTokenLoadNextRecordsQuery(function executor(c) {
				cancelLoadNextRecordsQuery = c
			}),
		}
		let bodyParameters = {
			filter: filter || {},
			viewKey: viewKey,
		}
		bodyParameters.filter.conditions = []
		if (viewSession) {
			bodyParameters = { ...bodyParameters, viewSession }
		}

		return axios.post(`${url}/devices/query`, bodyParameters, config)
	},

	updateViewData(view, token, cancelToken) {
		return axios.put(`${url}/views/${view.key}`, view, {
			headers: apiHeader(token),
			cancelToken: cancelToken?.token,
		})
	},

	insertViewData(view, token, cancelToken) {
		return axios.post(`${url}/views`, view, {
			headers: apiHeader(token),
			cancelToken: cancelToken?.token,
		})
	},
}
